/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_Add_FailedInputs */

const en_files_add_failed = /** @type {(inputs: Files_Add_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not add the files to the folder.`)
};

const es_files_add_failed = /** @type {(inputs: Files_Add_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron agregar los archivos a la carpeta.`)
};

/**
* | output |
* | --- |
* | "Could not add the files to the folder." |
*
* @param {Files_Add_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_add_failed = /** @type {((inputs?: Files_Add_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Add_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_add_failed(inputs)
	return en_files_add_failed(inputs)
});